import { inventoryMediaQueryKeys as e } from "./useInventoryMediaQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { experiencesApi as n, servicesApi as r } from "@maat/api-main";
import { ImageProcessingStatus as i } from "@maat/api-main/types";
//#region src/inventoryMedia/useInventoryImagesQuery.ts
var a = 3e3, o = (e, t) => e === "experience" ? n.getExperienceImages(t) : r.getServiceImages(t), s = (n, r, s) => {
	let c = s?.poll ?? !0;
	return t({
		queryKey: e.images(n, r),
		queryFn: () => o(n, r),
		refetchInterval: (e) => c && (e.state.data?.images ?? []).some((e) => e.processing_status === i.Pending) ? a : !1
	});
};
//#endregion
export { s as useInventoryImagesQuery };
